import { ESignAccountBaseUrlEnum } from '@monetize/types/app';

export const DOCUSIGN_ACCOUNT_URL_TO_OAUTH_URL_MAPPING = {
  [ESignAccountBaseUrlEnum.DEMO]: 'https://account-d.docusign.com/oauth/auth',
  [ESignAccountBaseUrlEnum.PRODUCTION]:
    'https://account.docusign.com/oauth/auth',
  [ESignAccountBaseUrlEnum.PRODUCTION_EU]:
    'https://account.docusign.com/oauth/auth',
};

export const DocusignAccountUrlDisplay = [
  { title: 'Demo', value: ESignAccountBaseUrlEnum.DEMO },
  { title: 'Production', value: ESignAccountBaseUrlEnum.PRODUCTION },
  { title: 'Production (EU)', value: ESignAccountBaseUrlEnum.PRODUCTION_EU },
];

export const DocusignAccountUrlDisplayForProduction = [
  { title: 'Production', value: ESignAccountBaseUrlEnum.PRODUCTION },
  { title: 'Production (EU)', value: ESignAccountBaseUrlEnum.PRODUCTION_EU },
  { title: 'Demo', value: ESignAccountBaseUrlEnum.DEMO },
];

export const DOCUSIGN_ACCOUNT_BASE_URL_TO_ENVIRONMENT_MAPPING = {
  [ESignAccountBaseUrlEnum.DEMO]: 'Demo',
  [ESignAccountBaseUrlEnum.PRODUCTION]: 'Production',
  [ESignAccountBaseUrlEnum.PRODUCTION_EU]: 'Production (EU)',
};
